import { counselorTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;

let counselor_url = `${SCHOOL_BASE}/counselor`;
// let eswa_url = `${SCHOOL_BASE}/com/wa`;

export const getAdmissionEnquiryTable = (params) =>
  counselorTokenAxios.get(`${counselor_url}/getAdmissionEnquiryTable`, {
    params: params,
  });

export const assignMultipleAdmissionEnquiryToStaff = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/assignMultipleAdmissionEnquiryToStaff`,
    payload
  );
};

export const editAdmissionProbability = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/editAdmissionProbability`,
    payload
  );
};

export const deleteAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.delete(
    `${counselor_url}/deleteAdmissionEnquiry/${payload}`
  );
};

export const changeStatusOfAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/changeStatusOfAdmissionEnquiry`,
    payload
  );
};

//Form Fee Structure
export const getFormFeeStructure = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getFormFeeStructure`, {
    params: params,
  });
};

export const addFormFeeStructure = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/addFormFeeStructure`,
    payload
  );
};

export const updateFormFeeStructure = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/updateFormFeeStructure`,
    payload
  );
};

export const getCounselorDropdownList = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getCounselorDropdownList`, {
    params: params,
  });
};

export const addAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/addAdmissionEnquiry`,
    payload
  );
};

export const getClassListFromPreviousSchool = (params) => {
  return counselorTokenAxios.get(
    `${counselor_url}/getClassListFromPreviousSchool`,
    {
      params: params,
    }
  );
};

export const getDistinctSources = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getDistinctSources`, {
    params: params,
  });
};

// Previous School
export const getPreviousSchoolNameList = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getPreviousSchoolNameList`, {
    params: params,
  });
};

export const addPreviousSchool = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/addPreviousSchool`,
    payload
  );
};

export const editPreviousSchool = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/editPreviousSchool`,
    payload
  );
};

export const deleteClassFromPreviousSchool = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/deleteClassFromPreviousSchool`,
    payload
  );
};

export const deletePreviousSchool = (payload) => {
  return counselorTokenAxios.delete(
    `${counselor_url}/deletePreviousSchool/${payload}`
  );
};

export const addClassInPreviousSchool = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/addClassInPreviousSchool`,
    payload
  );
};

export const viewAdmissionEnquirybasicInfo = (params) => {
  return counselorTokenAxios.get(
    `${counselor_url}/viewAdmissionEnquirybasicInfo`,
    {
      params: params,
    }
  );
};
export const getFollowUpdetail = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getFollowUpdetail`, {
    params: params,
  });
};
export const getDistinctStatus = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getDistinctStatus`, {
    params: params,
  });
};
export const changeEnquiryStatusOfAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/changeEnquiryStatusOfAdmissionEnquiry`,
    payload
  );
};

//communication thread
export const createAdmissionEnquiryThread = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/createAdmissionEnquiryThread`,
    payload
  );
};

export const editAdmissionEnquiryThread = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/editAdmissionEnquiryThread`,
    payload
  );
};

export const deleteAdmissionEnquiryThread = (payload) => {
  return counselorTokenAxios.delete(
    `${counselor_url}/deleteAdmissionEnquiryThread/${payload}`
  );
};

export const getEnquiryCreatedByList = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getEnquiryCreatedByList`, {
    params: params,
  });
};
export const collectFormPayment = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/collectFormPayment`,
    payload
  );
};

export const getBulkAdmissionEnquiryJsonFormat = (params) => {
  return counselorTokenAxios.get(
    `${counselor_url}/getBulkAdmissionEnquiryJsonFormat`,
    {
      params: params,
    }
  );
};

export const bulkUploadAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/bulkUploadAdmissionEnquiry`,
    payload
  );
};

export const getClassDropdown = (params) =>
  counselorTokenAxios.get(
    `${counselor_url}/getClassDropdown/${params?.schoolDocId}`,
    {
      params: params?.payload,
    }
  );

export const updateAdmissionEnquiry = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/updateAdmissionEnquiry`,
    payload
  );
};

export const getSchoolProfile = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getSchoolProfile`, {
    params: params,
  });
};

export const getStudentByName = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getStudentByName`, {
    params: params,
  });
};

export const getStudentByNameAndSession = (params) => {
  return counselorTokenAxios.get(
    `${counselor_url}/getStudentByNameAndSession`,
    {
      params: params,
    }
  );
};

//permission by staff

export const removeStaffPermission = (payload) => {
  return counselorTokenAxios.put(
    `${counselor_url}/removeStaffPermission`,
    payload
  );
};

export const getStaffByName = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getStaffByName`, {
    params: params,
  });
};

export const getDistinctBlockList = (payload) =>
  counselorTokenAxios.get(`${counselor_url}/getDistinctBlockList`, {
    payload,
  });

export const getDistinctTehsilList = (payload) =>
  counselorTokenAxios.get(`${counselor_url}/getDistinctTehsilList`, {
    payload,
  });

export const getStatusList = (payload) =>
  counselorTokenAxios.get(`${counselor_url}/getStatusList`, { payload });

// source
export const getSourceList = (payload) =>
  counselorTokenAxios.get(`${counselor_url}/getSourceList`, { payload });

export const getCounselor = (params) => {
  return counselorTokenAxios.get(`${counselor_url}/getCounselor`, {
    params: params,
  });
};

export const getDistinctAreaOfCounselor = (params) => {
  return counselorTokenAxios.get(
    `${counselor_url}/getDistinctAreaOfCounselor`,
    {
      params: params,
    }
  );
};

//FOR WHATSAPP

export const createWaCampaign = (payload) => {
  return counselorTokenAxios.post(`${counselor_url}/createWaCampaign`, payload);
};

export const getWhatsAppTemplates = (payload) => {
  return counselorTokenAxios.get(`${counselor_url}/getWhatsAppTemplates`, {
    params: payload,
  });
};

export const sendWhatsAppTemplate = (payload) => {
  return counselorTokenAxios.post(
    `${counselor_url}/sendWhatsAppTemplate`,
    payload
  );
};
